/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _WeakMap from "@babel/runtime-corejs3/core-js-stable/weak-map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

/** @module react/classes/sophistication */
import { create } from 'jss';
import { default as jssPresetDefault } from 'jss-preset-default';
var customJss = create().setup(jssPresetDefault()); // TODO: ADD HOOKS SUPPORT FOR FUNCTIONAL COMPONENTS.
// TODO: SEE react-jss SOURCE CODE TO SEE HOW STYLESHEETS ARE HANDLED. CREATION, UPDATE AND DELETION! TO BE AS OPTIMIZED AS POSSIBLE.

/**
 * @classdesc A class for library components sophistication.
 */

var Sophistication = /*#__PURE__*/function () {
  /**
   * @description Constructor.
   * @param {Object<string,*>} styles - JSS styles object.
   */
  function Sophistication(styles) {
    _classCallCheck(this, Sophistication);

    _defineProperty(this, "styles", void 0);

    _defineProperty(this, "styleSheets", void 0);

    this.styles = styles;
    this.styleSheets = new _WeakMap();
  }
  /**
   * @description Attached stylesheet.
   * @param {Object<string,*>} component - Component instance.
   * @returns {void} Void.
   */


  _createClass(Sophistication, [{
    key: "setup",
    value: function setup(component) {
      if (this.styleSheets.has(component)) {
        return;
      }

      var styleSheet = customJss.createStyleSheet(this.styles, {
        link: true
      });
      styleSheet.attach();
      this.styleSheets.set(component, styleSheet);
    }
    /**
     * @description Detaches stylesheet and removes it from registry.
     * @param {Object<string,*>} component - Component instance.
     * @returns {void} Void.
     */

  }, {
    key: "destroy",
    value: function destroy(component) {
      var styleSheet = this.styleSheets.get(component);

      if (!styleSheet) {
        return;
      }

      customJss.removeStyleSheet(styleSheet);
      this.styleSheets.delete(component);
    }
    /**
     * @description Updates stylesheet and returns classes object.
     * @param {Object<string,*>} component - Component instance.
     * @param {Object<string,*>} params - Styles parameters.
     * @returns {Object<string,string>} Classes object.
     */

  }, {
    key: "getClassNames",
    value: function getClassNames(component, params) {
      var styleSheet = this.styleSheets.get(component);

      if (!styleSheet) {
        return {};
      }

      styleSheet.update(params);
      return styleSheet.classes;
    }
  }]);

  return Sophistication;
}();

export { Sophistication };